<template>
  <div class="add-block-wrap" :class="$store.state.editor.device">
    <template v-if="widget.getMenuInfo().draggable">
      <div v-if="$store.getters.isDesktop">
        <div class="add-block-opener" @click.stop.prevent="handleShowAddBlock">
          <button class="add-block-opener__btn">
            <add-svg />
            <span class="ml-8px">{{ $t('添加区块') }}</span>
          </button>
        </div>
      </div>
      <template v-else>
        <div slot="reference" class="add-block-opener" @click.stop.prevent="handleShowAddBlock">
          <button class="p-0 add-block-opener__btn">
            <add-svg class="transform scale-150" />
          </button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import { Message } from 'element-ui'
import mobileAddBlock from './mobile'
import addSvg from '~/assets/svg/icon/add-green.svg?inline'
import closeSvg from '~/assets/svg/icon/close-white.svg?inline'
import { insertReduceStep } from "~/utils/event";
import { scrollToWidget } from "~/site/core";
import { DialogCollectionWidgetModel } from '~/site/model/models/DialogCollectionWidgetModel'
import { ModuleTitleEnum } from '~/enums/siteEnum'
export default {
  components: {
    addSvg,
    closeSvg,
    mobileAddBlock
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    canDrag: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0,
    },
    widget: {
      type: Object,
      default() {
        return {
          getMenuInfo() {
            return {
              draggable: true
            }
          }
        };
      }
    },
    model: {
      type: Object,
      required: true,
      default() {
        return {
          getCanAddWidget() {
          }
        }
      }
    }
  },
  data() {
    return {
      show: this.value,
      currentId: ''
    }
  },
  computed: {
    isActive() {
      return (this.$store.state.editor.currentModel.id === this.widget.id) && this.show
    },
    hasDialogCollect() {
      return Boolean(this.model.widgetList.find(item => item.name === DialogCollectionWidgetModel.moduleClass))
    }
  },
  methods: {
    checkAddWidget(item) {
      let result = true
      if (this.hasDialogCollect && item.title === ModuleTitleEnum.DialogCollection) {
        result = false
        Message.error('弹窗集模块只可添加一个，请勿重复添加')
      }
      return result
    },
    addWidgetByIndex(item) {
      if (!this.checkAddWidget(item)) return
      const index = this.index + 1
      let model
      if (item?.children?.length) {
        model = this.model.addWidgetByIndex(item.children[0].model, index)
      } else {
        model = this.model.addWidgetByIndex(item.model, index)
      }
      insertReduceStep(this, { element: cloneDeep(model), index })
      scrollToWidget(this, model, index)
      this.show = false
    },
    handleCloseAddMenu() {
      this.show = false
    },
    handleShowAddBlock() {
      // this.show = true
      this.$emit('show-add-block', this.index)
      this.$store.commit('editor/SET_CURRENT_MODEL', { id: this.widget.id })
    }
  }
}
</script>

<style lang="less">
.add-block-wrap.@{mobile} {
  .add-block-opener {
    top: -15px;
  }
}

.add-block-opener {
  width: 100%;
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  z-index: 40;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  max-width: 820px;
  margin: 0 auto;
  color: var(--text-color);
  text-transform: uppercase;
  border: 1px dashed transparent;
  cursor: pointer;
  border-radius: @border-radius-base;

  &:hover {
    border: 1px dashed @primary-1;
  }

  &__btn {
    // 尺寸与排版
    font-size: .8em;
    line-height: 36px;
    border-radius: 999px;
    padding: 0 18px;
    display: inline-flex;
    letter-spacing: .06em;
    align-items: center;
    gap: 8px;

    // 视觉与层次
    color: #fff;
    background: linear-gradient(135deg, lighten(@primary-1, 8%), @primary-1);
    border: 1px solid fade(#fff, 10%);
    box-shadow: 0 6px 18px fade(@primary-1, 25%), 0 2px 6px fade(#000, 10%);
    opacity: 0.88;

    // 动效与可用性
    transition: transform .15s ease, box-shadow .15s ease, opacity .2s ease;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 22px fade(@primary-1, 28%), 0 3px 8px fade(#000, 12%);
      opacity: 1;
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 4px 14px fade(@primary-1, 22%), 0 2px 6px fade(#000, 12%);
      opacity: .95;
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px fade(@primary-1, 30%), 0 8px 22px fade(@primary-1, 28%);
    }
  }
}

.add-block {
  width: 100%;
  text-align: center;
  height: 0;
  max-height: 0;
  box-sizing: border-box;
  overflow: hidden;
  opacity: 0;

  //transition: height 0.3s ease, max-height 0.3s ease;
  &.no-padding {
    padding: 0;
  }

  &__title {
    color: white;
  }

  &__items {
    display: flex;
    margin-top: 24px;
    padding: 0 24px 3rem 24px;
    align-items: center;
    overflow: auto;
    overflow-y: hidden;
    max-width: 100%;
  }

  &__item {
    cursor: pointer;
    opacity: .5;
    transition: opacity .2s ease;
    max-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 80px;
    flex-shrink: 0;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      opacity: 1;
    }

    &-img {
      width: 80px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.6);
      border-radius: 100%;
    }

    &-title {
      margin-top: 8px;
      text-align: center;
      font-size: 14px;
      color: white;
    }
  }

  &.add-block__open {
    height: 226px;
    max-height: 226px;
    background-color: @primary-1;
    opacity: 1;
  }
}
</style>
